<template>
     <div>
        <div class="func" v-if="can_edit">
            <input class="number-input"  @focus="addflag = false" @input="addflag = false" @keyup.enter="addNumber" v-model.trim="task_number" ref="union-input"  placeholder="添加已发布的任务编号">
            <div class="front-btn" @click="addNumber">添加</div>
            <transition name="fade">
                <div class="func-tip" v-show="addflag">{{ addTip }}</div>
            </transition>
        </div>
        <z-scrollDiv class="wrap" :speed="20">
            <div class="routerlink" v-for="(item,index) in task_union" :key="item.id" >
                <!-- <a @click="openUnion(item.union_task_id)">
                    {{ item.union_number }} - {{item.union_task_name}}
                </a> -->
                <a @click="openPop(item)">
                    {{ item.union_number }} - {{item.union_task_name}}
                </a>
                <span v-if="can_edit" class="del" @click.stop.prevent="delUnion(item.union_task_id,index)">删除
                </span>
                <!-- <span v-else-if="userJudge" class="del" @click.stop.prevent="delUnion2(item.union_task_id,index)">删除
                </span> -->
            </div>

        </z-scrollDiv>

        <z-windowPop @cancel="pop.show = false" :show="pop.show" :height="'80%'" :noBtns="true" :title="`任务编号：${pop.title}`" :black="true">
            <readDetail :taskId="pop.id" :prohibit="true"></readDetail>
        </z-windowPop>
    </div>
</template>

<script>
    import readDetail from "src/components/read-taskDetail.vue";
    
    import { mapState } from "vuex";

    export default {
        components:{
            readDetail,
        },
        props:["taskId","read","detailData"],
        data(){
            return {
                task_number: '',    //关联输入框
                addflag: false,   //提示信息显示判断器
                addTip: "",   //添加关联任务的提示信息
                task_union: [],  //关联任务的信息列表

                pop:{
                    show:false,
                    title:"",
                    id:"",
                },
                
                unionData:{},     //任务详情
                showUnion:false,  //大弹窗控制器
            }
        },

        computed:{
            ...mapState(["buInfo"]),
            can_edit(){   // 可添加/可删除
                return !(this.read || this.detailData.sub_bu_id == this.buInfo.id);
            }, 
            task_id(){   //任务id
                let str = this.$route.params.task_id;
                return this.taskId || this.$crypto.decrypt(str);
            },
        },

        watch:{
            detailData(detail){
                this.task_union = [...detail.task_union];
            }
        },

        methods:{
            showAddTip(str) { //显示关联任务的报错
                this.$refs["union-input"].focus();
                this.addTip = str;
                this.addflag = true;
            },
            addNumber:(()=> {  //添加关联任务
                let flag = false; 
                return function(){
                    if(flag){
                        return;
                    }
                    flag = true;

                    if (!/^[A-Za-z]\d+$/.test(this.task_number)) {
                        this.showAddTip('请输入正确的任务编号');
                        flag = false;
                        return;
                    }

                    //筛选任务id
                    let addId = this.task_number.replace(/^[A-Za-z]0*/g, "");
                    console.log(`addId: ${addId}`);

                    if (addId == this.task_id) {
                        this.showAddTip('不能关联自己');
                        flag = false;
                        return;
                    }

                    if (this.task_union.some(item => { return item.union_task_id == addId })) {
                        this.showAddTip('不能重复添加任务');
                        flag = false;
                        return;
                    }

                    let url = `api/clerk/task/union/${this.task_id}`;
                    this.$http.post(url, {
                        sub_task_detail_id:addId,
                    }).then(res => {
                        if(res.status == 200){
                            this.task_union.push(res.res_data);
                            this.addflag = false;
                            this.task_number = "";
                            this.successTip("添加成功");

                        }else if(res.status == 900){
                            this.showAddTip(res.message);
                        }
                        flag = false;

                    }).catch(error => {
                        this.showAddTip("添加失败");
                        flag = false;
                    });

                }
            })(),
            delUnion(id,index) {  //删除关联任务 数据库删除
                let url = `api/clerk/task/union/${this.task_id}`;
                
                this.$http.delete(url,{
                    data:{sub_task_detail_id:id}
                }).then(res=>{
                    if(res.status == 200){
                        this.delList(index);
                        this.successTip("删除成功");
                    }else if (res.status == 900){
                        this.showAddTip(res.message);
                    }
                }).catch(err=>{
                    this.errorTip("刪除失败");
                });
            },
            delList(index) {  //删除关联任务 列表删除
                this.task_union.splice(index, 1);
            },

            openPop(item){  //打开弹窗
                this.pop.id = item.union_task_id;
                this.pop.title = item.union_number;
                this.pop.show = true;
            },
            // openUnion(id){
            //     var newUrl = this.url + id;
            //     this.$http.get(newUrl).then(res => {
            //         this.unionData = res.data;
            //         this.showUnion = true;
            //         console.log("彈窗打開");
            //     });
            // },

        },
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    @max-w:470px;

    .func{
        width:@max-w;
        font-size:0;
        .number-input{
            display:inline-block;
            width: 178px;
            border: 1px solid @border-c;
            border-radius: 3px;
            // padding: 10px 15px;
            padding:0 10px;
            transition: 0.3s;
            font-size:12px;
            line-height:30px;
            &:hover {
                border-color: @hover-c;
            }
            &:focus {
                border-color: @focus-c;
            }
        }
        .front-btn{
            margin-left:15px;
        }
        .func-tip{
            color:@red;
            display:inline-block;
            font-size:12px;
            margin-left:15px;
        }
    
    }

    .wrap{
        width:@max-w;
        height:128px;
        border:1px solid @border-c;
        box-sizing:border-box;
        border-radius:4px;
        margin-top:15px;
        padding:0 10px;

        .routerlink{
            background: #fafafa;
            border: 1px solid #e3e3e3;
            border-radius: 4px;
            font-size:12px;
            padding:4px 10px;
            margin-top:6px;
            &:last-child{
                margin-bottom: 10px;
            }
            a{
                cursor:pointer;
                color:@focus-c;
            }
            span{
                float:right;
                cursor: pointer;
            }
        }

    }
</style>





// WEBPACK FOOTER //
// relation-task.vue?3d3b9187